import { BASE_API_URL } from "./constants.js"

export const sendMail = async (formData, priceEstimate) => {
    const response = await fetch(BASE_API_URL + 'mails/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            ...formData,
            priceEstimate: priceEstimate,
        }),
    })
    return (response.status >= 200) && (response.status <= 299)
}
